import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { NAVIGATOR_TEST_DRIVE_DEEP_LINK, navigatorFallbackUrl } from './promo'
import { openExternalUrl } from './openExternal'

const FALLBACK_DELAY_MS = 1400

/**
 * Try Navigator’s test-drive deep link; if the app does not open, fall back to web demo with UTMs.
 */
export async function openNavigatorHandoff(utmContent: string): Promise<void> {
  const fallback = navigatorFallbackUrl(utmContent)

  if (!Capacitor.isNativePlatform()) {
    await openExternalUrl(fallback)
    return
  }

  let leftApp = false
  const listener = await App.addListener('appStateChange', ({ isActive }) => {
    if (!isActive) leftApp = true
  })

  const timer = window.setTimeout(() => {
    void listener.remove()
    if (!leftApp) void openExternalUrl(fallback)
  }, FALLBACK_DELAY_MS)

  window.location.href = NAVIGATOR_TEST_DRIVE_DEEP_LINK

  window.setTimeout(() => {
    if (leftApp) {
      window.clearTimeout(timer)
      void listener.remove()
    }
  }, FALLBACK_DELAY_MS + 400)
}
